var map = {
	"./Building.png": "daa2",
	"./Dashboard.png": "68cc",
	"./Form.png": "72c3",
	"./Plus.png": "9ede",
	"./User.png": "6968",
	"./User1.png": "c7f2",
	"./android-chrome-192x192.png": "35fd",
	"./android-chrome-512x512.png": "d5a1",
	"./apple-touch-icon-120x120.png": "62b3",
	"./apple-touch-icon-152x152.png": "7de7",
	"./apple-touch-icon-180x180.png": "6330",
	"./apple-touch-icon-60x60.png": "64aa",
	"./apple-touch-icon-76x76.png": "50d4",
	"./apple-touch-icon.png": "41c2",
	"./favicon-16x16.png": "82b7",
	"./favicon-32x32.png": "8940",
	"./msapplication-icon-144x144.png": "72a3",
	"./mstile-150x150.png": "8f6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24c8";